/** @format */

/**
 * Product price after processing through ProductSelectionService / ProductSelectionPricingService
 */
export interface ProductPrice {
  ecodeLevelPrice?: boolean;
  emptyPrice?: boolean;
  mapPriceIndicator?: number;
  maxListPrice: string | number;
  maxOfferPrice: string | number;
  maxSavingPct?: string | number;
  minListPrice: string | number;
  minOfferPrice: string | number;
  minSavingPct?: string | number;
  priceIndicator?: number;
}

export interface BundlePrice {
  fullSetPrice: ProductPrice;
  individualItemPrice: ProductPrice;
}
